(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-multi-column-footer"] && !Shopify.designMode) return;
  try {
    
  class LuxuryFooterComponent extends HTMLElement {
    connectedCallback() {
      this.boundClick = this.onClick.bind(this);
      this.boundResize = this.onResize.bind(this);

      this.addEventListener('click', this.boundClick);
      window.addEventListener('resize', this.boundResize);
      this.syncAccordionState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClick);
      window.removeEventListener('resize', this.boundResize);
    }

    onResize() {
      this.syncAccordionState();
    }

    onClick(event) {
      const toggle = event.target.closest('.luxury-footer__menu-toggle');
      if (toggle && this.contains(toggle) && window.matchMedia('(max-width: 989px)').matches) {
        const controlsId = toggle.getAttribute('aria-controls');
        const controlledMenu = controlsId ? this.querySelector('#' + controlsId) : null;

        if (!controlledMenu) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        controlledMenu.hidden = expanded;

        const icon = toggle.querySelector('.luxury-footer__menu-toggle-icon');
        if (icon) {
          icon.textContent = expanded ? '+' : '-';
        }
      }

      const backToTop = event.target.closest('.luxury-footer__back-to-top');
      if (backToTop && this.contains(backToTop)) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      }
    }

    syncAccordionState() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      const toggles = this.querySelectorAll('.luxury-footer__menu-toggle');

      toggles.forEach((toggle) => {
        const controlsId = toggle.getAttribute('aria-controls');
        const controlledMenu = controlsId ? this.querySelector('#' + controlsId) : null;
        if (!controlledMenu) return;

        if (isDesktop) {
          toggle.setAttribute('aria-expanded', 'true');
          controlledMenu.hidden = false;
        } else {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          controlledMenu.hidden = !expanded;
        }
      });
    }
  }

  if (!customElements.get('luxury-footer-component')) {
    customElements.define('luxury-footer-component', LuxuryFooterComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-hub-locator"] && !Shopify.designMode) return;
  try {
    
  class HubLocatorComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    onClick(event) {
      const tab = event.target.closest('[data-hub-tab]');
      if (!tab || !this.contains(tab)) return;

      this.selectTab(tab);
    }

    onKeydown(event) {
      const tab = event.target.closest('[data-hub-tab]');
      if (!tab || !this.contains(tab)) return;

      let modifier = 0;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          modifier = 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          modifier = -1;
          break;
        default:
          return;
      }

      event.preventDefault();

      const tabs = Array.from(this.querySelectorAll('[data-hub-tab]'));
      const currentIndex = tabs.indexOf(tab);
      const nextIndex = (currentIndex + modifier + tabs.length) % tabs.length;
      const nextTab = tabs[nextIndex];

      this.selectTab(nextTab);
      nextTab.focus();
    }

    selectTab(tab) {
      const target = tab.getAttribute('data-hub-tab');

      this.querySelectorAll('[data-hub-tab]').forEach((t) => {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.tabIndex = t === tab ? 0 : -1;
      });

      this.querySelectorAll('[data-hub-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-hub-panel') !== target;
      });
    }
  }

  if (!customElements.get('hub-locator-component')) {
    customElements.define('hub-locator-component', HubLocatorComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
